import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import styles from './usageIcon.module.scss';
import OnlineIcon from 'assets/img/icons/online.svg';
import InstoreIcon from 'assets/img/icons/instore.svg';
import PhoneIcon from 'assets/img/icons/phone.svg';
import CheckIcon from 'assets/img/icons/check.svg';
import CrossIcon from 'assets/img/icons/cross.svg';

const UsageIcon = (props) => {
  const { location, label, usage } = props;

  const locationIcon = useMemo(() => {
    return (
      {
        online: OnlineIcon,
        'in-store': InstoreIcon,
        phone: PhoneIcon,
      }[location] ?? null
    );
  }, [location]);

  const status = usage
    ? { icon: CheckIcon, color: '#4FA353' }
    : { icon: CrossIcon, color: '#F15E40' };

  return (
    <div className={styles.container}>
      <img src={locationIcon} alt={location} />
      <img
        src={status.icon}
        style={{
          borderRadius: '40px',
          padding: '4px',
          backgroundColor: status.color,
        }}
        alt=""
      />
      <div className={styles.label}>{label}</div>
    </div>
  );
};

UsageIcon.propTypes = {
  location: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  usage: PropTypes.bool.isRequired,
};

export default UsageIcon;
